import type { FilingBreakdown, NamedBreakdown } from '@/modules/account/types'
import { getFilingPath, getFolderPath, getProjectPath } from '@/utils'

export interface BreakdownRow {
  key: string
  label: string
  credits: number
  href: string | null
}

const UNASSIGNED = 'Unassigned'

const byCreditsDesc = (a: BreakdownRow, b: BreakdownRow) =>
  b.credits - a.credits

const namedRows = (
  rows: NamedBreakdown[],
  prefix: string,
  pathOf: (slug: string) => string,
): BreakdownRow[] =>
  rows
    .map((row) => ({
      key: row.id === null ? 'unassigned' : `${prefix}-${row.id}`,
      label: row.name ?? UNASSIGNED,
      credits: row.creditsConsumed,
      href: row.slug === null ? null : pathOf(row.slug),
    }))
    .sort(byCreditsDesc)

export const projectBreakdownRows = (rows: NamedBreakdown[]) =>
  namedRows(rows, 'project', (slug) => getProjectPath({ slug }))

export const folderBreakdownRows = (rows: NamedBreakdown[]) =>
  namedRows(rows, 'folder', (slug) => getFolderPath({ slug, kind: 'project' }))

export const filingBreakdownRows = (rows: FilingBreakdown[]): BreakdownRow[] =>
  rows
    .map((row) => ({
      key: `filing-${row.id}`,
      label: row.label,
      credits: row.creditsConsumed,
      href: getFilingPath({ id: row.id }),
    }))
    .sort(byCreditsDesc)
